import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id B9143BB9-06E0-40A3-8B38-D0687A1BEA69
 * name format-quote-open-outline
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-quote-open-outline.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatQuoteOpenOutlineIcon = createSvgIcon(<><path d="M11 18V10H9.12L11.12 6H5.38L3 10.76V18M9 16H5V11.24L6.62 8H7.88L5.88 12H9M21 18V10H19.12L21.12 6H15.38L13 10.76V18M19 16H15V11.24L16.62 8H17.88L15.88 12H19Z" /></>, 'FormatQuoteOpenOutlineIcon');
export default FormatQuoteOpenOutlineIcon